<div class="m" *ngIf="viewContent && getHTMLData">
    <button type="button" class="btn btn-primary mr-3 shadow-none no-print" (click)="faultPopup(del)">{{'Fault Found'|translate}}</button>
    <button type="button" class="btn btn-primary mr-3 shadow-none no-print" (click)="noFaultPopup()">{{'No Fault Found'|translate}}</button>
    <!-- <button type="button" style="margin-right: 2.4%;" class="reportAProblem pull-right" (click)="reportAProblemPopup()">{{'Report A Problem'|translate}} </button> -->
</div>
<div class="container" *ngIf="viewContent && getHTMLData">
    <div class="fdrs-view-card">
        <div class="card-body fdrs-view-card-body">
            <div class="fdrs-view-card1">
                <div class="card-body fdrs-view-card-body1">
                    <div class="fdrs-view-tab-header">
                        <label class="tab-header-label"></label>
                    </div>
                    <div *ngIf="newcontent" class="fdrs-view-content" [innerHTML]="displayHTML | pinpointPipe"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-dialog modal-dialog-scrollable">
    <ng-template #del let-modal>
        <div class="modal-content">
            <div class="modal-header">
                <div class="mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Fault found details'|translate}}
                </div>
                <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
            </div>
            <div class="fdrs-view-text">{{'Specify faulty component'|translate}}:</div>
            <div class="deleteContent">
                <select class="fdrs-view-dropdwn" [(ngModel)]="selectedValue" #setName>
                    <option *ngFor="let selectedValue of TEPostRepairDetails" [ngValue]="selectedValue">{{selectedValue.description}}</option>
                </select>
            </div>
            <div class="modal-footer fdrs-modal-footer">
                <button type="button" class="btn btn-primary mr-3 shadow-none"
                    (click)="modal.dismiss('Cross click')">{{'Abort'|translate}}</button>
                <button type="button" class="btn btn-primary mr-3 shadow-none"
                    (click)="continue();modal.dismiss('Cross click')">{{'Continue'|translate}}</button>
            </div>
        </div>
    </ng-template>
</div>
<div class="nospa-content" *ngIf="viewContent && !getHTMLData">
    <button type="button" class="btn btn-primary mr-3 shadow-none no-print nospa-closebtn"
        (click)="noFaultPopup()">{{'Close'|translate}}
    </button>
    <div class="nospa-header">{{'Information Not Available'|translate}}</div>
    <div class="nospa-title">{{'The information you have requested is not available at this time'|translate}}.</div>
</div>
<div id="overlay" *ngIf="viewDiagnosticCandidate">
    <span id="nav-spinner">
        <img src="assets/images/ajax-loader.gif" width="80" height="80">
    </span>
</div>
<ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" style="margin-top: 5%;" color="#003478" size="medium"
  type="ball-spin-clockwise">
  <p style="font-size: 20px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;"></p>
</ngx-spinner>